var cov_71aifsff2 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/util.ts",
      hash = "e371c46c2d66c9b69f9e326c1919b2812fce4e7b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/util.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 13
        },
        end: {
          line: 2,
          column: 56
        }
      },
      "1": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "formatSize",
        decl: {
          start: {
            line: 1,
            column: 16
          },
          end: {
            line: 1,
            column: 26
          }
        },
        loc: {
          start: {
            line: 1,
            column: 50
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 13
          },
          end: {
            line: 2,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 13
          },
          end: {
            line: 2,
            column: 50
          }
        }, {
          start: {
            line: 2,
            column: 54
          },
          end: {
            line: 2,
            column: 56
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 5,
            column: 10
          },
          end: {
            line: 5,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 5,
            column: 10
          },
          end: {
            line: 5,
            column: 15
          }
        }, {
          start: {
            line: 5,
            column: 19
          },
          end: {
            line: 5,
            column: 23
          }
        }],
        line: 5
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export function formatSize(size) {
  cov_71aifsff2.f[0]++;
  var ss = (cov_71aifsff2.s[0]++, (cov_71aifsff2.b[0][0]++, /^(\d+)([%|\w]*)$/.exec(String(size))) || (cov_71aifsff2.b[0][1]++, []));
  cov_71aifsff2.s[1]++;
  return {
    value: parseFloat(ss[1]),
    unit: (cov_71aifsff2.b[1][0]++, ss[2]) || (cov_71aifsff2.b[1][1]++, 'px')
  };
}